import { captureMessage } from "@sentry/react";
import { useState } from "react";
import { fetchSpaceData, importBlocks } from "../InitParamLoader";
import { Template } from "./data";
import { useBlocks } from "../../liveblocks/maps";
import { useSendAnalyticsEvent } from "../../analytics/events";

export function useTemplateImport() {
  const [importing, setImporting] = useState<Template["spaceId"]>();
  const { upsertBlock } = useBlocks();
  const sendAnalyticsEvent = useSendAnalyticsEvent();

  function importTemplate(tmpl: Template) {
    setImporting(tmpl.spaceId);

    sendAnalyticsEvent({
      name: "templateImport",
      templateName: tmpl.name,
      templateCategory: tmpl.category?.id,
    });

    fetchSpaceData(tmpl.spaceId)
      .then((blocks) => {
        importBlocks(blocks, upsertBlock);
      })
      .catch((error) => {
        captureMessage(error);
      })
      .finally(() => {
        setImporting(undefined);
      });
  }

  return { importTemplate, importing };
}
